<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <iframe v-if="show" frameborder="0" 
            ref="frame"
            :height="height"
            :width="frameWidth"
            class="frameField" :src="data[name]">
        </iframe>
    </el-col>
</template>

<style>
    .frameField{
        border: 0px;
    }
</style>

<script>
    import qweBaseField from "../BaseField";

    export default{
        mixins:[qweBaseField],
        name:"FrameField",
        data:function(){
            return {
                "frameWidth":"100%",
                "height":"100%"
            }
        },
        created:function(){
            this.frameWidth = this.selfSetting.Width;
            this.height = this.selfSetting.Height;
        }
    }
</script>